import React from "react";
import { Pagination } from "antd";

const PaginationDetailProfile = ({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  total,
}) => {
  const onShowSizeChange = (current, pageSize) => {
    setRowsPerPage(pageSize);
  };
  const onChange = (pageNumber) => {
    setPage(pageNumber);
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px",
      }}
    >
      <Pagination
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={onChange}
        current={page}
        total={total}
        pageSize={rowsPerPage}
      />
    </div>
  );
};

export default PaginationDetailProfile;
